<section id="order-details" *ngIf="data">
  <h2 *ngIf="!isRecla">Demande n°{{ data.numdemande }}</h2>
  <h2 *ngIf="isRecla">Réclamation n°{{ data.numrecla }}</h2>

  <p id="button">
    <button mat-raised-button color="primary" id="export-button" (click)="export(data)">
      Export (PDF)
    </button>
  </p>

  <section>
    <h3>Informations</h3>
    <article>
      <p>Votre compte&nbsp;&nbsp;<strong>{{data.client.code.substring(0,4)}} / {{data.client.code.substring(4,6)}} - {{data.client.libelle}}</strong></p>
      <p>Date de la {{ isRecla ? 'réclamation' : 'demande'}} <strong>{{ (isRecla ? data.date_reclamationM :
          data.date_demandeM) | momentFormat: 'DD/MM/YYYY' }}</strong></p>
      <p>Motif <strong>{{ isRecla ? data.id_motif1.libelle : data.titre }}</strong></p>
      <p *ngIf="!isRecla">Service destinataire <strong>{{ data.service_destinataire.libelle }}</strong></p>
      <p>Statut <strong>{{ isRecla ? (data.statut.statut == 'C' ? 'Traitée' : data.statut.libelle) : data.statut.libelle
          }}</strong></p>
    </article>
  </section>

  <section id="objet">
    <h3>Objet</h3>
    <article>
      <p>{{ isRecla ? data.objet : data.objetdemande }}</p>
    </article>
  </section>

  <section id="reponse"
    *ngIf="(!isRecla && canHaveReponse() && data.traite_reponse_client) || (isRecla && (data.statut.statut == 'T' || data.statut.statut == 'C'))">
    <h3>Réponse</h3>
    <article>
      <p>{{ data.traite_reponse_client }}</p>
    </article>
  </section>
  <section id="pj" *ngIf="data.file_name1 || data.file_name2 || data.file_name3">
    <h3>Pièces jointes</h3>
    <article>
      <p *ngIf="data.file_name1">
        <button mat-raised-button (click)="downloadFile1()" class="button-icon">
          <mat-icon>attach_file</mat-icon>
        </button>
        {{ data.file_name1 }}
      </p>
      <p *ngIf="data.file_name2">
        <button mat-raised-button (click)="downloadFile2()" class="button-icon">
          <mat-icon>attach_file</mat-icon>
        </button>
        {{ data.file_name2 }}
      </p>
      <p *ngIf="data.file_name3">
        <button mat-raised-button (click)="downloadFile3()" class="button-icon">
          <mat-icon>attach_file</mat-icon>
        </button>
        {{ data.file_name3 }}
      </p>
    </article>
  </section>
</section>